// extracted by mini-css-extract-plugin
module.exports = {"docx":"docx__3pqwF","docx__loader":"docx__loader__yyEtQ","docx__container":"docx__container__10pr7"};